<!-- 払い戻し選択 -->
<template>
  <TemplateMfittMyTicketRefund />
</template>

<script>
import TemplateMfittMyTicketRefund from "@/views/Templates/MFITT/TemplateMfittMyTicketRefund";

import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "MfittMyTicketRefund",
  components: {
    TemplateMfittMyTicketRefund,
  },
  setup() {},
};
</script>
